import 'ngToast';

import _ from 'lodash';
import enums from 'goodeggs-purchase-orders-sdk/purchase_order/enums';
import enumHelpers from 'goodeggs-purchase-orders-sdk/enums';
import moment from 'moment-timezone';

import './style.styl';

/*
Centralized logic that converts user input into stateParams to that can be used for querying purchaseOrders.
Designed to work with the purchaseOrderFilterService.
@param {Array} displayedFilters - 'search', 'status', 'statusAt', 'dropoffDay', 'dropoffWindow', 'confirmByDay'
@param {Array} purchaseOrders - reference where purchaseOrders will should populated once query finished
@param {String} [vendorSlug] - if included, purchaseOrders will be additionally filtered by vendor slug
*/
export default __filename;
angular
  .module(__filename, [
    'ui.router',
    require('local_modules/services/state_params_helper').default,
    'ngToast',
  ])

  .directive('purchaseOrderFilters', () => ({
    scope: {
      displayedFilters: '=',
    },
    controllerAs: 'ctrl',
    bindToController: true,
    template: require('./template'),
    controller: ngInject(function($stateParams, $state, stateParamsHelper, ngToast, rollbar) {
      this.filters = {
        searchBy: $stateParams.searchBy,
        status: $stateParams.status,
        statusDate: $stateParams.statusDate ? moment($stateParams.statusDate).toDate() : undefined,
        dropoffDay: $stateParams.dropoffDay
          ? moment($stateParams.dropoffDay, 'YYYY-MM-DD').toDate()
          : undefined,
        dropoffWindow: $stateParams.dropoffWindow,
        confirmByDay: $stateParams.confirmByDay,
      };

      this.enums = enums;
      this.statusLabel = enumHelpers.statusLabel;

      const generateDayOptions = function(currentDayOption) {
        const startOfDay = moment(currentDayOption, 'YYYY-MM-DD').startOf('day');
        let options = [
          {
            day: moment()
              .subtract(3, 'days')
              .startOf('day'),
          },
          {
            day: moment()
              .subtract(2, 'days')
              .startOf('day'),
          },
          {
            label: 'Yesterday',
            day: moment()
              .subtract(1, 'day')
              .startOf('day'),
          },
          {label: 'Today', day: moment().startOf('day')},
          {
            label: 'Tomorrow',
            day: moment()
              .add(1, 'day')
              .startOf('day'),
          },
          {
            day: moment()
              .add(2, 'days')
              .startOf('day'),
          },
          {
            day: moment()
              .add(3, 'days')
              .startOf('day'),
          },
        ];
        if (
          !options.find(
            (dayOption) => dayOption.day.format('YYYY-MM-DD') === startOfDay.format('YYYY-MM-DD'),
          )
        ) {
          options = options.concat([{label: 'Selected Day', day: startOfDay}]);
        }

        return _(options)
          .sortBy((dayOption) => dayOption.day.valueOf())
          .map(function({label, day}) {
            label = label != null ? ` (${label})` : '';
            return {value: day.format('YYYY-MM-DD'), label: day.format('dddd, MMM D') + label};
          })
          .value();
      };

      this.confirmByDayOptions = generateDayOptions($stateParams.confirmByDay);

      this.shouldShowStatusOn = () =>
        ['new', 'submitted', 'confirmed'].includes($stateParams.status);

      this.isFilterDisplayed = (filterName) =>
        Array.from(this.displayedFilters).includes(filterName);

      this.isFilterActive = (name, value) => stateParamsHelper.stateParamsContain(name, value);

      this.setFilter = (name, value) => {
        if (value instanceof Date) {
          value = value.toString();
        }
        return stateParamsHelper.setStateParam(name, value).catch((err) => {
          ngToast.danger('Oops! Something went wrong. Please try again later.');
          return rollbar.error(err);
        });
      };

      // like set filter, but ensures that date is converted to dayString before saving
      this.setDayFilter = (name, value) => {
        value = moment(value).format('YYYY-MM-DD');
        return stateParamsHelper.setStateParam(name, value).catch((err) => {
          ngToast.danger('Oops! Something went wrong. Please try again later.');
          return rollbar.error(err);
        });
      };

      // like toggle filter but clears statusDate first
      this.toggleStatus = (name, value) => {
        $stateParams.statusDate = undefined; // we need choose statusDate after we choose status
        return this.toggleFilter(name, value);
      };

      this.toggleFilter = (name, value) => {
        if (value instanceof Date) {
          value = value.toString();
        }
        return stateParamsHelper.toggleStateParam(name, value).catch((err) => {
          ngToast.danger('Oops! Something went wrong. Please try again later.');
          return rollbar.error(err);
        });
      };

      this.clearFilters = () => {
        delete $stateParams.statusDate;
        delete $stateParams.status;
        delete $stateParams.searchBy;
        return $state.go($state.current.name, $stateParams, {reload: true, inherit: false});
      };

      return this;
    }),
  }));
